import React from 'react';
import { THEME_CONFIG } from '../constants';

const AboutSection: React.FC = () => {
  return (
    <section id="about-section" className="py-20 bg-white dark:bg-gray-950">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary dark:text-white">Sobre {THEME_CONFIG.clinicName}</h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 mt-4 max-w-2xl mx-auto">
            Comprometidos con tu salud y bienestar desde el primer día.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img
              aria-label="Equipo de la clínica Salud Integral"
              name="Equipo de la clínica Salud Integral"
              id="Equipo de la clínica Salud Integral"
              width="500"
              height="500"
              src="https://i.ibb.co/M5tHbsdv/pexels-pixabay-236380.jpg" 
              alt="Equipo de la clínica Salud Integral"
              className="rounded-lg shadow-xl w-full"
            />
          </div>
          <div className="text-gray-700 dark:text-gray-300 space-y-6">
            <h3 className="text-2xl font-bold text-secondary dark:text-white">Nuestra Historia y Misión</h3>
            <p>
              Fundada hace más de 20 años, la Clínica {THEME_CONFIG.clinicName} nació con la misión de ofrecer una atención médica accesible, humana y de la más alta calidad. Creemos en un enfoque integral, donde no solo tratamos enfermedades, sino que también promovemos un estilo de vida saludable para toda la comunidad.
            </p>
            <h3 className="text-2xl font-bold text-secondary dark:text-white">Nuestra Filosofía</h3>
            <p>
              Nuestra filosofía se basa en tres pilares fundamentales:
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li><strong>Empatía:</strong> Escuchamos y entendemos las necesidades de cada paciente, ofreciendo un trato cercano y personalizado.</li>
              <li><strong>Innovación:</strong> Nos mantenemos a la vanguardia de la tecnología y los tratamientos médicos para garantizar los mejores resultados.</li>
              <li><strong>Compromiso:</strong> Estamos dedicados al bienestar a largo plazo de nuestros pacientes, acompañándolos en cada etapa de su vida.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;